/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Container, Spinner, Tab, Tabs } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import useShortListedCandidateAssessment from "./useShortListedCandidateAssessment";
import { dateFormatter } from "../../../_helpers/dateFormatter";
import Header from "../../Common/Header";
import SharedShortlistedCandidates from "./SharedShortlistedCandidates";

export default (props) => {
  const {
    loading,
    submittedCandidatesInterviewList,
    interviewKit,
    nextPage,
    sharedShortlistCandidates,
    countCompletedCandidates,
    shortlistCandidates,
    onViewAssessmentClick,
    onBackClick,
    editAssessmentKit,
    onPublicProfileClick,
    onShareAssessmentClick,
    onNextPageClick,
    onClickShortlist,
    onClickUnShortlist,
    ontabSelection,
  } = useShortListedCandidateAssessment(props);

  return (
    <>
      <Header />
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <>
          <div className="top bg-grey pb-2">
            <Container className="d-flex justify-content-between align-items-center">
              <div className="left">
                <p
                  className="text-primary mb-3 font-weight-medium cursor-pointer"
                  onClick={onBackClick}
                >
                  <FontAwesomeIcon icon={faAngleLeft} className="mr-2" />
                  Back
                </p>
                <h2 className="d-inline-block text-dark text-capitalize mr-3 mb-2">
                  {interviewKit?.title}
                </h2>
              </div>
            </Container>
          </div>
        </>
      )}
      <div className="kanban-board-main mt-4">
        <div className="container">
          <Tabs defaultActiveKey="ShortlistedCandidates" onSelect={() => ontabSelection()} className="mb-3">
            <Tab
              eventKey="ShortlistedCandidates"
              title="ShortListed Candidates"
            >
              <SharedShortlistedCandidates
                onClickUnShortlist={onClickUnShortlist}
                nextPage={nextPage}
                onNextPageClick={onNextPageClick}
                sharedShortlistCandidates={sharedShortlistCandidates}
                onViewAssessmentClick={onViewAssessmentClick}
                onPublicProfileClick={onPublicProfileClick}
                onShareAssessmentClick={onShareAssessmentClick}
                onClickShortlist={onClickShortlist}
                ShortlistedCandidates ={shortlistCandidates}
              />
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
};
